import script from "./testPath.vue?vue&type=script&setup=true&lang=js"
export * from "./testPath.vue?vue&type=script&setup=true&lang=js"

import "./testPath.vue?vue&type=style&index=0&id=bbb57464&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb57464"]])

export default __exports__